import ky from 'ky';
import { getKyClient } from './client';

export const fetchPersonalInfo = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/personalinfo`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchBalanceToSettle = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/balancetosettle`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchBalanceToSettleWithoutCancelFee = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/BalanceToSettleWithoutCanFee`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchActivePaymentMethod = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/ActivePayMethod`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchNextPayment = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/BillNextAmount`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchTransactions = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/TransactionsOverview`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchCallNotes = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/CallNotesOverview`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchMembershipDue = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/membershipdue`;
  const kyClient = await getKyClient();
  const result = await kyClient.get(url).json();
  return result.membershipDue;
};

export const postCancelAccount = async (adfitNo, data) => {
  const url = `v1.0/accounts/${adfitNo}/CancelAccount`;
  const kyClient = await getKyClient();
  return kyClient.post(url, {
    json: data,
  });
};

export const fetchEstimatedFinalBillDate = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/EstimatedFinalBillDate`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchOutstandingDsFee = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/OutstandingDsFees`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchDefaultFeeDue = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/DefaultFees`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

//Using default ky instance as the url can be different from the configured base path.
export const checkAccountCancelStatus = async (url, token) => {
  return ky
    .get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json;charset=utf-8',
        Accept: 'application/json;charset=utf-8',
      },
    })
    .json();
};

export const fetchGuarantorDetails = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/GetGuarantorDetails`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchPendingPaymentAmount = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/overview/PendingPaymentAmount`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};
